import { render } from "./FileDetail.vue?vue&type=template&id=170b21cc"
import script from "./FileDetail.vue?vue&type=script&lang=js"
export * from "./FileDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__